import { http } from './http';
import { postBulkAction } from './bulk.service';
import { unwrapData } from '../utils/unwrapApiData';

const dataOf = (payload) => unwrapData(payload) ?? payload;

export async function listMyNotifications(params = {}) {
  const { data } = await http.get('/me/notifications', { params });
  return dataOf(data);
}

export async function markNotificationRead(id) {
  const { data } = await http.post(`/me/notifications/${id}/read`);
  return dataOf(data);
}

export async function markAllNotificationsRead() {
  const { data } = await http.post('/me/notifications/read-all');
  return dataOf(data);
}

export async function clearAllNotifications() {
  const { data } = await http.delete('/me/notifications');
  return dataOf(data);
}

export async function bulkNotifications(body) {
  return postBulkAction('/me/notifications/bulk', body);
}
